export const ContactItems = [
    {
        title: 'Email',
        url: 'mailto:brettahuber@gmail.com',
        display: 'brettahuber@gmail.com',
        icon: 'images/iconmonstr-email.png',
        className: 'contact-links'
    },

    {
        title: 'Phone',
        display: '+1 (973) 356-8278',
        url: 'tel:9733568278',
        icon: 'images/iconmonstr-phone.png',
        className: 'contact-links'
    },

    {
        title: 'LinkedIn',
        display: 'linkedin.com/in/brett-huber/',
        url: 'https://www.linkedin.com/in/brett-huber/',
        icon: 'images/iconmonstr-linkedin.png',
        className: 'contact-links'
    },

    {
        title: 'Github',
        display: 'github.com/BrettHuber',
        url: 'https://github.com/BrettHuber',
        icon: 'images/iconmonstr-github.png',
        className: 'contact-links'
    }
]